<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <template v-if="fixpage">
        <div align="center">
          <span style="font-weight: bold;font-size: 40px">Coming Soon</span>
        </div>
      </template>
      <template v-else>
        <v-container v-show="Details">
          <v-card style="border: 1px solid">
            <v-toolbar
                color="primary">
              <v-card-title class="headline mb-1">
                <span style="color:white"> สมัครเข้าร่วมโครงการ</span>
              </v-card-title>
            </v-toolbar>
            <v-list-item>
              <v-row>
                <v-col
                    cols="12">
                  <v-expand-transition>
                    <v-card v-if="!Details_Cordi"
                            style="border: 1px solid"
                    >
                      <v-row
                          justify="center"
                          class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="12">
                          <v-card-title>
                            ตารางข้อมูลรายละเอียดโครงการ
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="ค้นหา รหัสโครงการ, โครงการ"
                                single-line
                                hide-details
                            ></v-text-field>
                          </v-card-title>
                        </v-col>
                      </v-row>
                      <v-list>
                        <v-list-item class="d-flex justify-center">
                          <v-radio-group row v-model="TypeProject" @change="ChooseTypeProject">
                            <v-radio label="โครงการทั้งหมด" value="0"></v-radio>
                            <v-radio label="โครงการที่กำลังเปิด - รอเปิดรับสมัคร" value="1"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                      </v-list>
                      <v-row
                          justify="center"
                          class="justify-center">
                        <v-col
                            cols="12"
                            md="12"
                        >

                          <!--                        @click:row="GetData"-->
                          <v-data-table
                              :headers="courseHeaders"
                              :items="projectDataToTable"
                              :search="search"
                              item-key="idx"
                              :single-expand="singleExpand"
                              :expanded.sync="expanded"
                              class="elevation-1"
                          >
                            <template v-slot:header.Project_code>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                รหัสโครงการ
                              </v-label>
                            </template>
                            <template v-slot:header.full_Name>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                โครงการ
                              </v-label>
                            </template>
                            <template v-slot:header.countReg>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                จำนวนผู้เข้าร่วม
                              </v-label>
                            </template>
                            <template v-slot:header.status_req>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                สถานะ
                              </v-label>
                            </template>
                            <template v-slot:header.remark>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                หมายเหตุ
                              </v-label>
                            </template>
                            <template v-slot:header.Count_Reg>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                จำนวนผู้สมัคร
                              </v-label>
                            </template>
                            <template v-slot:item.countReg="{item}">
                              <div v-html="item.countReg"></div>
                            </template>
                            <template v-slot:item.status_req="{item}">
                              <v-chip
                                  color="#6D4C41"
                                  style="transform: scale(0.8);color: white"
                                  v-if="item.status_req == '0'"
                              >
                                <span style="color: white">รอพิจารณา</span>
                              </v-chip>

                              <v-chip
                                  color="#00BFA5"
                                  style="transform: scale(0.8);color: white"
                                  v-else-if="item.status_req == '1'"
                              >
                                อนุมติเข้าร่วม
                              </v-chip>
                              <v-chip
                                  color="#F50057"
                                  style="transform: scale(0.8);color: white"
                                  v-else-if="item.status_req == '2'"
                              >
                                ไม่อนุมัติ
                              </v-chip>
                              <div v-else align="center">
                            <span style="font-weight: bold">
                            -
                          </span>
                              </div>

                            </template>
                            <template v-slot:item.Project_Details="{ item }">
                              <v-btn
                                  text
                                  class="darken-4"
                                  color="green"
                                  @click="OpenRegLink(item)"
                                  v-if="item.Status_Reg == '0'"
                              >
                                สมัครเข้าร่วม
                              </v-btn>
                              <v-btn
                                  text
                                  class="darken-4"
                                  color="purple"
                                  @click="ShowJoinProject(item)"
                              >
                                ตรวจสอบรายชื่อผู้เข้าร่วม
                              </v-btn>
                              <v-btn
                                  text
                                  class="darken-4"
                                  color="primary"
                                  @click="ShowCordiProject(item)"
                              >
                                เงื่อนไขเข้าร่วม
                              </v-btn>
                            </template>
                            <template v-slot:item.full_Name="{ item }">
                              <div v-html="item.full_Name"></div>
                            </template>
                            <template v-slot:expanded-item="{ headers, item }">
                              <td :colspan="headers.length">
                                <div v-for="(file, idx) in item.files" v-bind:key="idx">
                                  {{ item.files }}
                                  <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ :
                                    {{ file.File_name }}
                                  </v-btn>
                                </div>
                              </td>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expand-transition>
                </v-col>
              </v-row>
            </v-list-item>
            <v-card-text>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12">
                  <template v-if="Details_Cordi">

                    <v-list-item>
                      <v-btn
                          outlined
                          color="#FF5722"
                          @click="showDetails">
                        ย้อนกลับ
                      </v-btn>
                    </v-list-item>

                    <v-card class="justify-center pa-6 mt-7">
                      <v-card-title
                          color="primary"
                          style="background-color: burlywood"
                      >
                        <span style="color: blue;font-weight: bold">โครงการ : {{ project.Project_name }}</span>
                      </v-card-title>

                      <v-card-text class="mt-4">
                        <div align="center" v-if="GroupExamProject.length > 0">
                          <h3 style="color:darkred;">
                            กลุ่มตัวอย่าง
                          </h3>
                        </div>
                        <div v-for="(Exam_i,idxEx) in GroupExamProject" :key="idxEx" align="center">
                        <span style="font-weight: bold;color: #364eff">
                          *** {{ Exam_i.PosName }} อายุงาน : {{ Exam_i.WSYear }} ปี ถึง {{ Exam_i.WEYear }} ***
                        </span>
                        </div>
                        <div align="center" v-if="QoutaDepDataDump.length > 0" style="margin-top: 25px">
                          <h3 style="color:darkred;">
                            จำนวนโควตาหน่วยงานเข้าร่วมโครงการ
                          </h3>
                        </div>
                        <div v-for="(DepQ,idx) in QoutaDepDataDump" :key="idx" align="center">
                        <span v-if="DepQ.dep_type == '0'" style="font-weight: bold;color: #364eff">
                          *** หน่วยงาน : {{
                            (depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id).length > 0 ? depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id)[0].dep_name : 'ไม่พบข้อมูล')
                          }} จำนวน : {{
                            DepQ.count
                          }} คน ***
                        </span>
                          <span v-else style="font-weight: bold;color: #364eff">
                          *** กลุ่มหน่วยงาน : {{
                              (depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id).length > 0 ? depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id)[0].dep_name : 'ไม่พบข้อมูล')
                            }} จำนวน : {{ DepQ.count }} คน ***
                        </span>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card class="mt-7">
                      <v-toolbar
                          color="primary"
                          dark
                          flat
                      >
                        <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการ
                          {{ JoinPerson.length }} คน
                          <span v-if="project.Status_Count_Reg == '0'"> / {{ project.Count_Reg }} คน</span>
                          <span v-else> / ไม่จำกัด คน</span>
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="searchPerson"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-list>
                        <v-list-item>
                          <v-tabs
                              v-model="tab2"
                          >
                            <v-tab
                                key="requestProject"
                            >
                              รายชื่อผู้สมัคร (รอยืนยัน)
                            </v-tab>
                            <v-tab
                                key="ApproveRequest"
                                v-if="project.Owner"
                            >
                              คัดเลือกผู้สมัคร
                            </v-tab>
                            <v-tab
                                key="JoinProject"
                            >
                              รายชื่อผู้เข้าร่วม
                            </v-tab>
                          </v-tabs>
                        </v-list-item>
                        <v-tabs-items v-model="tab2">
                          <v-tab-item
                              key="requestProject"
                          >
                            <v-data-table
                                :headers="headersPerson2"
                                :items="RequestPerson"
                                :search="searchPerson"
                                item-key="uid"
                            >
                              <template v-slot:item.action="{item}">
                                <v-btn
                                    v-if="item.status_active == '0'"
                                    color="#F44336"
                                    outlined
                                    @click="Del_item(item)">
                                  ลบ
                                </v-btn>
                              </template>
                              <template v-slot:item.status_req="{item}">
                                <v-chip color="primary" v-if="item.status_req == '0'">
                                  รอพิจารณา
                                </v-chip>
                                <v-chip color="green" dark v-else-if="item.status_req == '1'">
                                  อนุมัติ
                                </v-chip>
                                <v-chip color="red" dark v-else>
                                  ไม่อนุมัติ
                                </v-chip>
                              </template>
                            </v-data-table>
                          </v-tab-item>
                          <v-tab-item
                              key="ApproveRequest"
                              v-if="project.Owner"
                          >
                            <v-data-table
                                :headers="headersPerson2"
                                :items="RequestPerson"
                                :search="searchPersonApprove"
                                :item-key="uid"
                            >
                              <template v-slot:item.remark="{item}">
                                <v-text-field v-model="item.remark" label="เหตุผล"></v-text-field>
                              </template>
                              <template v-slot:item.status_req="{item}">
                                <v-radio-group row v-model="item.status_req">
                                  <v-radio
                                      color="green"
                                      label="อนุมัติ"
                                      value="1"
                                  ></v-radio>
                                  <v-radio
                                      color="red"
                                      label="ไม่อนุมัติ"
                                      value="2"
                                  ></v-radio>
                                </v-radio-group>
                              </template>
                            </v-data-table>
                            <div align="center">
                              <v-btn outlined color="primary" @click="ChangeStatusReq">บันทึก</v-btn>
                            </div>
                          </v-tab-item>
                          <v-tab-item
                              key="JoinProject"
                          >
                            <v-data-table
                                :headers="headersPerson"
                                :items="JoinPerson"
                                :search="searchPerson"
                                item-key="uid"
                            >
                              <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                                <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                                <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                                <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                                <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                                <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                              </template>
                            </v-data-table>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-list>
                    </v-card>

                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-container>
        <v-dialog
            v-model="dialogLoading"
            persistent
            width="300"
        >
          <v-card
              color="primary"
              dark
          >
            <v-card-text>
              Loading...
              <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogJoinProject"
            persistent
            max-width="800"
            :retain-focus="false"
        >
          <v-card>
            <v-card-title
                color="primary"
                style="background-color: burlywood"
            >
                                <span style="color: blue;font-weight: bold"
                                      v-if="project != null">โครงการ : {{ project.Project_name }}</span>
            </v-card-title>

            <v-card-text class="mt-4">
              <div align="center">
                <h3 style="color:darkred;">
                  ผู้เข้าร่วมโครงการ
                </h3>
              </div>
              <div v-if="project != null">
                <div align="center" v-if="project.JoinData.length == 0">
                  <h3 style="color:darkred;">
                    ไม่พบข้อมูลผู้เข้าร่วมโครงการ
                  </h3>
                </div>
                <v-list-item>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-model="searchJoin"
                      label="ค้นหา"
                      v-if="project.JoinData.length > 0"
                  ></v-text-field>
                </v-list-item>
                <v-data-table
                    :headers="JoinHeader"
                    :items="project.JoinData"
                    :search="searchJoin"
                    v-if="project.JoinData.length > 0"
                ></v-data-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogJoinProject = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogCordiProject"
            persistent
            max-width="500"
            :retain-focus="false"
        >
          <v-card>
            <v-card-title
                color="primary"
                style="background-color: burlywood"
            >
                                <span style="color: blue;font-weight: bold"
                                      v-if="project != null">โครงการ : {{ project.Project_name }}</span>
            </v-card-title>

            <v-card-text class="mt-4">
              <div align="center" v-if="GroupExamData.length > 0">
                <h3 style="color:darkred;">
                  กลุ่มตัวอย่าง
                </h3>
              </div>
              <div align="center" v-else>
                <h3 style="color:darkred;">
                  ไม่พบข้อมูลกลุ่มตัวอย่าง
                </h3>
              </div>
              <div v-for="(Exam_i,idxEx) in GroupExamData" :key="idxEx" align="center">
                        <span style="font-weight: bold;color: #364eff">
                          *** {{ Exam_i.PosName }} อายุงาน : {{ Exam_i.WSYear }} ปี ถึง {{ Exam_i.WEYear }} ***
                        </span>
              </div>
              <div align="center" v-if="QoutaDepDataDump.length > 0" style="margin-top: 25px">
                <h3 style="color:darkred;">
                  จำนวนโควตาหน่วยงานเข้าร่วมโครงการ
                </h3>
              </div>
              <div align="center" v-else>
                <h3 style="color:darkred;">
                  ไม่พบข้อมูลโควตาหน่วยงานเข้าร่วมโครงการ
                </h3>
              </div>
              <div v-for="(DepQ,idx) in QoutaDepDataDump" :key="idx" align="center">
                        <span v-if="DepQ.dep_type == '0'" style="font-weight: bold;color: #364eff">
                          *** หน่วยงาน : {{
                            (depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id).length > 0 ? depart.filter(dep_i => dep_i.dep_id == DepQ.dep_id)[0].dep_name : 'ไม่พบข้อมูล')
                          }} จำนวน : {{
                            DepQ.count
                          }} คน ***
                        </span>
                <span v-else style="font-weight: bold;color: #364eff">
                          *** กลุ่มหน่วยงาน : {{
                    (depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id).length > 0 ? depart.filter(dep_i => dep_i.dep_group_id == DepQ.dep_group_id)[0].dep_name : 'ไม่พบข้อมูล')
                  }} จำนวน : {{ DepQ.count }} คน ***
                        </span>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogCordiProject = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../const/Const";
import {mapActions, mapGetters} from "vuex";
import Vue from 'vue'
import ALlFunc from "@/FuncGlobal/ALlFunc";
import Const from "@/const/Const";

export default {
  name: "Project2",
  data() {
    return {
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      fixpage: false,
      searchJoin: '',
      dialogJoinProject: false,
      GroupExamData: [],
      TypeProject: '1',
      ProjectQuotaDepCount: 0,
      dialogCordiProject: false,
      TypeRequest: '2',
      OwnerProject: false,
      staffDataDump: [],
      QoutaDepData: [],
      QoutaDepDataDump: [],
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      projectDataToTableDump: [],
      projectDataToTableDump2: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      tab2: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      searchPerson2: '',
      searchPersonJoin: '',
      searchPersonApprove: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'สถานะ', value: 'type'},
      ],
      headersPerson2: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'dep_name'},
        {text: 'สถานะ', value: 'status_req'},
        {text: 'เหตุผล', value: 'remark'},
        {text: '', value: 'action'}
      ],
      JoinHeader: [
        {text: 'ชื่อ', value: 'name'},
        {text: 'สกุล', value: 'sname'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type_details'}
      ],
      JoinPerson: [],
      RequestPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      courseHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'จำนวนผู้เข้าร่วม', value: 'countReg'},
        {text: 'สถานะ', value: 'status_req'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      QuotaDepart: 'Project/getQuotaDepart',
      GroupExamProject: 'Project/getGroupExamProject',
      RequestProject: 'Project/getRequestProject',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      UrlRegister: 'Project/getUrl',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initQuotaDepartRegister: 'Project/initQuotaDepartRegister',
      initRequestProject: 'Project/initRequestProject',
      initRequestProjectByEmp: 'Project/initRequestProjectByEmp',
      initJoinProject: 'Project/initJoinProject',
      initGroupExamProject: 'Project/initGroupExamProject',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      getJoinProjectByCordiAndUid: 'Project/getJoinProjectByCordiAndUid',
      getJoinProjectByUid: 'Project/getJoinProjectByUid',
      getUrlRegisterBycordi: 'Project/getUrlRegisterBycordi',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    init: function () {
      this.initProjectRoundData().then(res => {
        if (res) {
          this.initProject()
        } else {
          this.dialogLoading = false
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    initProject() {
      this.projectDataToTable = []
      this.projectDataToTableDump = []
      this.staffDataDump = []
      var txtDateS = ''
      var txtDateE = ''
      var txtCount = ''
      var txtCount2 = ''

      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name
            })

            this.initProjectDataForApprove({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                if (this.projectForApprove.length > 0) {
                  this.projectDataToTableDump = this.projectForApprove.filter(item => item.Status_Reg == '0' && (item.Status_Type_Reg == '0' || item.Status_Type_Reg == '2'))
                  this.projectDataToTableDump.map(Project => {
                    Project.Project_name = Project.Project_name.replace(/&quot;/g, '"')
                    if (this.staffData.filter(staffi => staffi.perid == Project.Create_By).length > 0) {
                      if (Project.IsRoundStatus == '0') {
                        txtDateS = ''
                        txtDateE = ''
                        txtCount = ''
                        txtCount2 = ''
                        if (Project.DateS_Reg != null && Project.DateS_Reg != '0000-00-00') {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateS_Reg) + '</span>'
                        } else {
                          txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                        }
                        if (Project.DateE_Reg != null && Project.DateE_Reg != '0000-00-00') {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(Project.DateE_Reg) + '</span>'
                        } else {
                          txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                        }
                        if (Project.Status_Count_Reg == '1') {
                          txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                          txtCount2 = '<span style="font-weight: bold;font-size: 25px">&#8734;</span>'
                        } else {
                          if (Project.Count_Reg != null && Project.Count_Reg != '') {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + Project.Count_Reg + '</span>'
                            txtCount2 = Project.Count_Reg
                          } else {
                            txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                            txtCount2 = '-'
                          }
                        }

                        this.projectDataToTable.push({
                          ...Project,
                          idx: this.projectDataToTable.length,
                          Ref_id: this.projectDataToTable.length,
                          full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span>' + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                              ' <div>' + txtCount + '</div>',
                          full_name2: Project.Project_name.replace(/&quot;/g, '"'),
                          JoinData: [],
                          requestData: [],
                          status_req: null,
                          remark: '',
                          countReg: null,
                          txtCount: txtCount2,
                          Owner: true,
                          project_id: Project.project_id
                        })
                      } else {
                        var RoundDump = this.ProjectRound.filter(roundI => roundI.Project_code == Project.Project_code)
                        if (RoundDump.length > 0) {
                          RoundDump.map(RoundI => {
                            txtDateS = ''
                            txtDateE = ''
                            txtCount = ''
                            txtCount2 = ''
                            if (RoundI.DateS_Reg != null && RoundI.DateS_Reg != '0000-00-00') {
                              txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateS_Reg) + '</span>'
                            } else {
                              txtDateS = '<span style="font-weight: bold;color: #ff6d81">วันที่เปิดรับสมัคร - </span>'
                            }
                            if (RoundI.DateE_Reg != null && RoundI.DateE_Reg != '0000-00-00') {
                              txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร ' + Vue.filter('DateToThai')(RoundI.DateE_Reg) + '</span>'
                            } else {
                              txtDateE = '<span style="font-weight: bold;color: #ff6d81">วันที่ปิดรับสมัคร - </span>'
                            }
                            if (RoundI.Status_Count_Reg == '1') {
                              txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ไม่จำกัด </span>'
                              txtCount2 = '<span style="font-weight: bold;font-size: 25px">&#8734;</span>'
                            } else {
                              if (RoundI.Count_Reg != null && RoundI.Count_Reg != '') {
                                txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ ' + RoundI.Count_Reg + '</span>'
                                txtCount2 = RoundI.Count_Reg
                              } else {
                                txtCount = '<span style="font-weight: bold;color: #42b983">จำนวนที่เปิดรับ - </span>'
                                txtCount2 = '-'
                              }
                            }

                            this.projectDataToTable.push({
                              ...RoundI,
                              idx: this.projectDataToTable.length,
                              Ref_id: RoundI.id,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + RoundI.Project_name + '</span>'
                                  + '<span style="font-weight: bold;color: magenta;margin-left: 10px">( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')</span>'
                                  + ' <div>' + txtDateS + ' ' + txtDateE + '</div>' +
                                  ' <div>' + txtCount + '</div>',
                              full_name2: Project.Project_name.replace(/&quot;/g, '"') + ' ( รุ่น ' + RoundI.Round + ' ' + RoundI.Round_name + ')',
                              JoinData: [],
                              requestData: [],
                              status_req: null,
                              remark: '',
                              countReg: null,
                              txtCount: txtCount2,
                              Owner: true,
                              project_id: Project.project_id
                            })
                          })
                        }

                      }
                    }
                  })

                  if (this.projectDataToTable.length > 0) {
                    var count = 0
                    this.projectDataToTable.map((proj_I) => {
                      var url = ''
                      if (proj_I.IsRoundStatus == '0') {
                        url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + proj_I.Project_code + '/active/1/?limit=9999'
                      } else {
                        url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + proj_I.Project_code + '/active/1/D_project_round_id/' + proj_I.Ref_id + '/?limit=9999'
                      }
                      axios.get(url).then(res => {
                        if (res.data) {
                          if (res.data.length > 0) {
                            var ProjectReq = res.data.filter(reqI => reqI.D_project_round_id == proj_I.Ref_id)
                            if (ProjectReq.length > 0) {
                              proj_I.JoinData = res.data
                              proj_I.countReg = res.data.length + ' / ' + proj_I.txtCount
                            } else {
                              proj_I.JoinData = res.data
                              proj_I.countReg = res.data.length + ' / ' + proj_I.txtCount
                            }
                          } else {
                            if (res.data.D_project_round_id == proj_I.Ref_id) {
                              proj_I.JoinData = new Array(res.data)
                              proj_I.countReg = 1 + ' / ' + proj_I.txtCount
                            } else {
                              proj_I.JoinData = new Array(res.data)
                              proj_I.countReg = 1 + ' / ' + proj_I.txtCount
                            }
                          }
                        } else {
                          proj_I.countReg = 0 + ' / ' + proj_I.txtCount
                        }
                      })

                      this.initRequestProject({
                        Project_code: proj_I.Project_code
                      }).then(resReq => {
                        if (resReq) {
                          if (this.RequestProject.length > 0) {
                            if (proj_I.IsRoundStatus == '0') {
                              var ProjectReq = this.RequestProject.filter(reqI => reqI.perid == this.MeData[0].perid)
                            } else {
                              ProjectReq = this.RequestProject.filter(reqI => reqI.perid == this.MeData[0].perid && reqI.D_project_round_id == proj_I.Ref_id)
                            }
                            if (ProjectReq.length > 0) {
                              proj_I.requestData = this.RequestProject
                              proj_I.status_req = ProjectReq[0].status_req
                              proj_I.remark = ProjectReq[0].remark
                            }
                          }
                        }
                        count++
                        if (count == this.projectDataToTable.length) {
                          this.ChooseTypeProject()
                        }
                      }).catch(reason => {
                        if (reason) {
                          count++
                          if (count == this.projectDataToTable.length) {
                            this.ChooseTypeProject()
                          }
                        }
                      })

                      // this.initJoinProject({
                      //   Project_code: proj_I.Project_code
                      // }).then(resReq => {
                      //   if (resReq) {
                      //     if (this.JoinProject.length > 0) {
                      //       var ProjectReq = this.JoinProject.filter(reqI => reqI.perid == this.MeData[0].perid && reqI.D_project_round_id == proj_I.Ref_id)
                      //       if (ProjectReq.length > 0) {
                      //         proj_I.JoinData = this.JoinProject
                      //         proj_I.status_req = ProjectReq[0].status_req
                      //         proj_I.remark = ProjectReq[0].remark
                      //         proj_I.countReg = this.JoinProject.length + ' / ' + proj_I.txtCount
                      //       } else {
                      //         proj_I.countReg = this.JoinProject.length + ' / ' + proj_I.txtCount
                      //       }
                      //     }
                      //   } else {
                      //     proj_I.countReg = 0 + ' / ' + proj_I.txtCount
                      //   }
                      //   if (idx == this.projectDataToTable.length - 1) {
                      //     this.ChooseTypeProject()
                      //   }
                      // }).catch(reason => {
                      //   if (reason) {
                      //     proj_I.countReg = 0 + ' / ' + proj_I.txtCount
                      //
                      //     if (idx == this.projectDataToTable.length - 1) {
                      //       this.ChooseTypeProject()
                      //     }
                      //   }
                      // })
                    })
                  }

                  this.dialogLoading = false
                } else {
                  this.dialogLoading = false
                }
              } else {
                this.dialogLoading = false
              }
            }).catch(reason => {
              if (reason) {
                this.dialogLoading = false
              }
            })
          }
        }
      })

      this.initQuotaDepartRegister()

      this.initDepartData()

      this.initPositionsData()

      this.initlevelData()

      this.initCardData()

    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    ChooseTypeProject() {
      if (this.projectDataToTableDump2.length == 0) {
        this.projectDataToTableDump2 = this.projectDataToTable
      }
      this.projectDataToTable = []
      if (this.TypeProject == '0') {
        this.projectDataToTable = this.projectDataToTableDump2
      } else {
        this.projectDataToTableDump2.map(item => {
          if ((item.DateS_Reg != '0000-00-00' && item.DateS_Reg != null) && (item.DateE_Reg != '0000-00-00' && item.DateE_Reg != null)) {
            if (item.DateE_Reg >= ALlFunc.getDateNow2(new Date())) {
              this.projectDataToTable.push(item)
            }
          } else if ((item.DateS_Reg != '0000-00-00' && item.DateS_Reg != null) && (item.DateE_Reg == '0000-00-00' || item.DateE_Reg == null)) {
            if (ALlFunc.getDateNow2(new Date()) >= item.DateS_Reg) {
              this.projectDataToTable.push(item)
            }
          } else if ((item.DateS_Reg == '0000-00-00' || item.DateS_Reg == null) && (item.DateE_Reg != '0000-00-00' && item.DateE_Reg != null)) {
            if (item.DateE_Reg <= ALlFunc.getDateNow2(new Date())) {
              this.projectDataToTable.push(item)
            }
          }
        })
      }
    },
    ChooseTypeRequest() {
      var DepCreate = []
      var DepData = []
      if (this.projectDataToTableDump.length == 0) {
        this.projectDataToTableDump = this.projectDataToTable
      }
      if (this.TypeRequest == '0') {
        this.projectDataToTable = this.projectDataToTableDump
      } else if (this.TypeRequest == '1') {
        this.projectDataToTable = []
        if (this.Permission_Dep.length > 0) {
          this.projectDataToTableDump.map(Project => {
            if (this.staffData.filter(staffi => staffi.perid == Project.Create_By).length > 0) {
              DepCreate = this.staffData.filter(staffi => staffi.perid == Project.Create_By)
              DepData = this.Permission_Dep.filter(Dep => DepCreate[0].dep_id == Dep.dep_id)
              if (DepData.length > 0) {
                this.projectDataToTable.push(Project)
              }
            }
          })
        }
      } else {
        this.projectDataToTable = []
        this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Status_Reg == '0' && (item.Status_Type_Reg == '0' || item.Status_Type_Reg == '1'))
      }
    },
    ChangeStatusReq() {
      var count = 0
      var RequestDump = this.RequestPerson.filter(item => item.status_req != '0')
      this.dialogLoading = true
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          if (RequestDump.length > 0) {
            RequestDump.map(item => {
              this.staffData.map((staff_I) => {
                if (item.perid == staff_I.perid) {
                  this.insertJoinProject({
                    Project_code: this.project.Project_code,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    id_card: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }, item.status_req).then(res => {
                    if (res) {
                      this.updateStatusReq(item).then(itemReq => {
                        if (itemReq) {
                          count++
                          if (count == RequestDump.length) {
                            this.dialogLoading = false
                            this.updateRequestProject()
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        } else {
                          count++
                          if (count == RequestDump.length) {
                            this.dialogLoading = false
                            this.updateRequestProject()
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                        }
                      })
                    } else {
                      count++
                      if (count == RequestDump.length) {
                        this.dialogLoading = false
                        this.updateRequestProject()
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                      }
                    }
                  })
                }
              })
            })
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'พิจารณาคัดเลือกผู้สมัครเข้าร่วมโครงการ อย่างน้อย 1 ท่านก่อนทำการบันทึกข้อมูล'
            })
          }
        } else {
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    insertJoinProject(item, status) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxiosDEL = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      return new Promise(resolve => {
        if (status == '1') {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code + '/uid/' + item.uid + '/active/1/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(resGet => {
            if (resGet.data) {
              resolve(false)
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', item, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            }
          })
        } else {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code + '/uid/' + item.uid, '', headerAxiosDEL).then(resDel => {
            if (resDel.data.status) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        }
      })
    },
    updateStatusReq(item) {
      return new Promise(resolve => {
        const headerAxiosPUT = {
          headers: {
            'Content-Type': 'application/json',
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/id/' + item.id, {
          status_req: item.status_req,
          remark: item.remark,
          status_active: '1'
        }, headerAxiosPUT).then(res => {
          if (res.data.status) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    updateRequestProject() {
      this.JoinPerson = []
      this.RequestPerson = []
      this.initJoinProject({
        Project_code: this.project.Project_code
      }).then(resJoin => {
        if (resJoin) {
          this.JoinProject.map(Join_i => {
            this.JoinPerson.unshift({
              ...Join_i,
              full_Name: Join_i.name + ' ' + Join_i.sname,
              idCard: Join_i.id_card,
              status_reg_person: '0'
            })
          })
        }
      })
      this.initRequestProject({
        Project_code: this.project.Project_code
      }).then(res => {
        if (res) {
          if (this.RequestProject.length > 0) {
            this.staffData.map((staff_I) => {
              this.RequestProject.map(itemReq => {
                if (staff_I.perid == itemReq.perid) {
                  this.RequestPerson.unshift({
                    ...staff_I,
                    id: itemReq.id,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    status_req: itemReq.status_req,
                    status_active: itemReq.status_active,
                    position: '',
                    phone: '',
                    remark: itemReq.remark,
                    registerType_id: 0,
                  })
                }
              })
            })
          }
        }
      })
    },
    insertRegisterProject(item) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        if (this.JoinPerson.length > 0) {
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, '', headerAxios).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, {
                status_reg: item.status_reg,
                Update_By: this.MeData[0].perid
              }, headerAxios).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project/D_Project_Register_id/' + this.project.D_Project_Register_id + '/uid/' + item.uid, {
                uid: item.uid,
                status_reg: item.status_reg,
                D_Project_Register_id: this.project.D_Project_Register_id,
                Create_BY: this.MeData[0].perid,
                Create_Time: 'now()',
              }, headerAxiosPUT).then(res => {
                if (res.data.status) {
                  resolve(true)
                } else {
                  resolve(false)
                }
              })
            }
          })

        }
      })
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    insertPersonUni() {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.JoinPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            this.personalMedData.map(value => {
              if (this.IdPersonal == value.STAFF_ID) {
                if (this.JoinPerson.filter(item => item.uid == value.STAFF_ID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...value,
                    uid: value.STAFF_ID,
                    full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    idCard: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                  })
                  this.IdPersonal = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: value.STAFF_ID,
                    name: value.STAFF_NAME_THAI,
                    sname: value.STAFF_SNAME_THAI,
                    id_card: value.STAFF_PERS_ID,
                    affiliation: value.FAC_NAME_THAI,
                    position: '',
                    phone: '',
                    registerType_id: 2,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI + ' สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            })
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    insertStd(msg) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (msg == 'med') {
              this.studentData.map(value => {
                if (this.Idstudent == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                    })
                    this.Idstudent = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: 'คณะแพทยศาสตร์',
                      position: '',
                      phone: '',
                      registerType_id: 1,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              })
            } else {
              this.studentUniData.map(value => {
                if (this.IdstudentUni == value.STUDENT_ID) {
                  if (this.JoinPerson.filter(item => item.uid == value.STUDENT_ID).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...value,
                      uid: value.STUDENT_ID,
                      full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      idCard: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                    })
                    this.IdstudentUni = ''
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      uid: value.STUDENT_ID,
                      name: value.STUD_NAME_THAI,
                      sname: value.STUD_SNAME_THAI,
                      id_card: value.CITIZEN_ID,
                      affiliation: value.FAC_NAME_THAI,
                      position: '',
                      phone: '',
                      registerType_id: 3,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    })
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }

                }
              })
            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }

    },
    Del_item(item) {
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/perid/' + item.perid, '', headerAxios).then(res => {
            if (res.data.status) {
              this.updateRequestProject()
              this.$swal.fire({
                timer: 1500,
                showConfirmButton: false,
                icon: 'success',
                title: 'ลบข้อมูลผู้เข้าร่วมโครงการ ' + item.full_Name + ' สำเร็จ!!'
              })
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    OpenRegLink(item) {
      this.getUrlRegisterBycordi({
        url: (item.IsRoundStatus == '0') ? 'D_project_id/' + item.project_id : 'D_project_id/' + item.project_id + '/D_project_round_id/' + item.Ref_id
      }).then(res => {
        if (res) {
          if (this.UrlRegister.length > 0) {
            window.open(
                this.UrlRegister[0].url,
                '_blank' // <- This is what makes it open in a new window.
            );
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลลิงค์การรับสมัครโครงการ ' + item.Project_name + ' โปรดติดต่อเจ้าของโครงการ'
            })
          }
        }
      }).catch(res => {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด ไม่พบข้อมูลลิงค์การรับสมัครโครงการ ' + item.Project_name + ' โปรดติดต่อเจ้าของโครงการ'
        })
        console.log(res)
      })
    },
    RequestRegister(item) {
      var CheckCordi = false
      var CheckCordi2 = '0'
      this.project = null
      this.project = item
      this.GroupExamData = []
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการสมัครเข้าร่วมโครงการ : " + item.full_name2.replace(/&quot;/g, '"') + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          if (item.IsRoundStatus == '0') {
            this.getJoinProjectByUid({
              Project_code: item.Project_code,
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                if (this.JoinProject.length == 0) {
                  if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                    if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '1'
                    }
                  } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
                    if (this.GetDateNow() >= item.DateS_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '2'
                    }
                  } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                    if (this.GetDateNow() <= item.DateE_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '3'
                    }
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '4'
                  }

                  if (CheckCordi) {
                    this.QoutaDepDataDump = []
                    this.DepQuotaData = []
                    this.ProjectQuotaDepCount = 0

                    this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                    this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
                    if (this.QoutaDepDataDump.length > 0) {
                      this.QoutaDepDataDump.map(DepQ => {
                        this.ProjectQuotaDepCount += parseInt(DepQ.count)
                      })
                      this.DepQuotaData = this.QoutaDepDataDump
                    }

                    this.initGroupExamProject({
                      Project_code: this.project.Project_code
                    }).then(res => {
                      if (res) {
                        if (item.IsRoundStatus == '0') {
                          this.GroupExamData = this.GroupExamProject
                        } else {
                          var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                          if (GroupExDump.length > 0) {
                            this.GroupExamData = GroupExDump
                          }
                        }

                        this.ChooseEmpolyee_s()
                      }
                    }).catch(reason => {
                      if (reason) {
                        this.ChooseEmpolyee_s()
                      }
                    })
                  } else {
                    switch (CheckCordi2) {
                      case "1":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                        })
                        break
                      case "2":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                        })
                        break
                      case "3":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                        })
                        break
                      case "4":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                        })
                        break
                      default:
                        break
                    }
                  }
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากคุณได้เป็นผู้เข้าร่วมโครงการ ' + item.full_name2.replace(/&quot;/g, '"') + ' อยู่แล้ว !!'
                  })
                }
              }
            }).catch(reason => {
              if (reason) {
                if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                  if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '1'
                  }
                } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
                  if (this.GetDateNow() >= item.DateS_Reg) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '2'
                  }
                } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                  if (this.GetDateNow() <= item.DateE_Reg) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '3'
                  }
                } else {
                  CheckCordi = false
                  CheckCordi2 = '4'
                }

                if (CheckCordi) {
                  this.QoutaDepDataDump = []
                  this.DepQuotaData = []
                  this.ProjectQuotaDepCount = 0

                  this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                  this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
                  if (this.QoutaDepDataDump.length > 0) {
                    this.QoutaDepDataDump.map(DepQ => {
                      this.ProjectQuotaDepCount += parseInt(DepQ.count)
                    })
                    this.DepQuotaData = this.QoutaDepDataDump
                  }

                  this.initGroupExamProject({
                    Project_code: this.project.Project_code
                  }).then(res => {
                    if (res) {
                      if (item.IsRoundStatus == '0') {
                        this.GroupExamData = this.GroupExamProject
                      } else {
                        var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                        if (GroupExDump.length > 0) {
                          this.GroupExamData = GroupExDump
                        }
                      }

                      this.ChooseEmpolyee_s()
                    }
                  }).catch(reason => {
                    if (reason) {
                      this.ChooseEmpolyee_s()
                    }
                  })
                } else {
                  switch (CheckCordi2) {
                    case "1":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                      })
                      break
                    case "2":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                      })
                      break
                    case "3":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                      })
                      break
                    case "4":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                      })
                      break
                    default:
                      break
                  }
                }
              }
            })
          } else {
            this.getJoinProjectByCordiAndUid({
              Project_code: item.Project_code,
              id: item.Ref_id,
              perid: this.MeData[0].perid,
            }).then(res => {
              if (res) {
                if (this.JoinProject.length == 0) {
                  if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                    if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '1'
                    }
                  } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
                    if (this.GetDateNow() >= item.DateS_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '2'
                    }
                  } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                    if (this.GetDateNow() <= item.DateE_Reg) {
                      CheckCordi = true
                    } else {
                      CheckCordi = false
                      CheckCordi2 = '3'
                    }
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '4'
                  }

                  if (CheckCordi) {
                    this.QoutaDepDataDump = []
                    this.DepQuotaData = []
                    this.ProjectQuotaDepCount = 0

                    this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                    this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
                    if (this.QoutaDepDataDump.length > 0) {
                      this.QoutaDepDataDump.map(DepQ => {
                        this.ProjectQuotaDepCount += parseInt(DepQ.count)
                      })
                      this.DepQuotaData = this.QoutaDepDataDump
                    }

                    this.initGroupExamProject({
                      Project_code: this.project.Project_code
                    }).then(res => {
                      if (res) {
                        if (item.IsRoundStatus == '0') {
                          this.GroupExamData = this.GroupExamProject
                        } else {
                          var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                          if (GroupExDump.length > 0) {
                            this.GroupExamData = GroupExDump
                          }
                        }
                        this.ChooseEmpolyee_s()
                      }
                    }).catch(reason => {
                      if (reason) {
                        this.ChooseEmpolyee_s()
                      }
                    })
                  } else {
                    switch (CheckCordi2) {
                      case "1":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                        })
                        break
                      case "2":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                        })
                        break
                      case "3":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                        })
                        break
                      case "4":
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                        })
                        break
                      default:
                        break
                    }
                  }
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากคุณได้เป็นผู้เข้าร่วมโครงการ ' + item.full_name2.replace(/&quot;/g, '"') + ' อยู่แล้ว !!'
                  })
                }
              }
            }).catch(reason => {
              if (reason) {
                if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                  if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '1'
                  }
                } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
                  if (this.GetDateNow() >= item.DateS_Reg) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '2'
                  }
                } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
                  if (this.GetDateNow() <= item.DateE_Reg) {
                    CheckCordi = true
                  } else {
                    CheckCordi = false
                    CheckCordi2 = '3'
                  }
                } else {
                  CheckCordi = false
                  CheckCordi2 = '4'
                }

                if (CheckCordi) {
                  this.QoutaDepDataDump = []
                  this.DepQuotaData = []
                  this.ProjectQuotaDepCount = 0

                  this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
                  this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
                  if (this.QoutaDepDataDump.length > 0) {
                    this.QoutaDepDataDump.map(DepQ => {
                      this.ProjectQuotaDepCount += parseInt(DepQ.count)
                    })
                    this.DepQuotaData = this.QoutaDepDataDump
                  }

                  this.initGroupExamProject({
                    Project_code: this.project.Project_code
                  }).then(res => {
                    if (res) {
                      if (item.IsRoundStatus == '0') {
                        this.GroupExamData = this.GroupExamProject
                      } else {
                        var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
                        if (GroupExDump.length > 0) {
                          this.GroupExamData = GroupExDump
                        }
                      }
                      this.ChooseEmpolyee_s()
                    }
                  }).catch(reason => {
                    if (reason) {
                      this.ChooseEmpolyee_s()
                    }
                  })
                } else {
                  switch (CheckCordi2) {
                    case "1":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
                      })
                      break
                    case "2":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
                      })
                      break
                    case "3":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
                      })
                      break
                    case "4":
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
                      })
                      break
                    default:
                      break
                  }
                }
              }
            })
          }
        }
      })
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s()
      }
    },
    checkKeyEnterOwner(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s_owner()
      }
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      var CheckDupe = false
      var checkPermiss = false
      if (this.PermissionAdmin.length > 0) {
        if (event.key == "Enter") {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }

              }
            } else {
              if (!checkPermiss && idx == this.PermissionAdmin.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      } else {
        if (event.key == "Enter") {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '7001') {
              checkPermiss = true
              GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
              if (GetData.length > 0) {
                if (this.JoinPerson.filter(item => item.uid == GetData[0].PERID).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
                  this.JoinPerson.unshift({
                    ...GetData[0],
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    idCard: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.cardSel = ''
                  this.insertDataToDB({
                    Project_code: this.project.Project_code,
                    D_project_round_id: this.project.id,
                    uid: GetData[0].perid,
                    name: GetData[0].name,
                    sname: GetData[0].surname,
                    id_card: GetData[0].citizen_id,
                    affiliation: GetData[0].dep_name,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  })
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูล ' + GetData[0].full_Name + ' รหัส (' + GetData[0].perid + ') สำเร็จ!!'
                  })
                } else {
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                  })
                }
              }
            } else {
              if (!checkPermiss && idx == this.Permission.length - 1) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            }
          })
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      var countPerson = 0
      // var CheckQuotaProject = false
      var CheckGroupExample = []
      // if (this.project.Status_Count_Reg == '0' && this.RequestPerson.length >= parseInt(this.project.Count_Reg)) {
      //   this.$swal.fire({
      //     icon: 'error',
      //     title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
      //   })
      // } else {
      this.staffData.map((staff_I) => {
        if (staff_I.perid == this.MeData[0].perid) {
          if (this.GroupExamData.length > 0) {
            CheckGroupExample = this.GroupExamData.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.WSYear && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.WEYear)
            if (CheckGroupExample.length > 0) {
              if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true
                      if (this.project.requestData.length > 0) {
                        if (this.project.requestData.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                          if (this.project.IsRoundStatus == '0') {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                              CheckDupe = true
                            }
                          }

                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              D_project_round_id: this.project.id,
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                this.projectDataToTableDump2 = ''
                                this.init()
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                          })
                        }
                      } else {
                        if (this.project.IsRoundStatus == '0') {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                            CheckDupe = true
                          }
                        } else {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                            CheckDupe = true
                          }
                        }
                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            D_project_round_id: this.project.id,
                            perid: staff_I.perid,
                            status_req: '0',
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                              this.projectDataToTableDump2 = ''
                              this.init()
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      }
                    } else {
                      if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                        if (this.project.Status_Count_Reg == '1') {
                          if (this.project.IsRoundStatus == '0') {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                              CheckDupe = true
                            }
                          }
                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              D_project_round_id: this.project.id,
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                this.projectDataToTableDump2 = ''
                                this.init()
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          countPerson = 0
                          this.project.requestData.map(reqP => {
                            if (dep_quota.dep_id == reqP.dep_id) {
                              countPerson++
                            }
                          })

                          if ((this.project.requestData.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                            if (this.project.IsRoundStatus == '0') {
                              if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                                CheckDupe = true
                              }
                            } else {
                              if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                                CheckDupe = true
                              }
                            }

                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                D_project_round_id: this.project.id,
                                perid: staff_I.perid,
                                status_req: '0',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                  this.projectDataToTableDump2 = ''
                                  this.init()
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                      if (DepGroup.length > 0) {
                        if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                          CheckDepMatch = true
                          if (this.project.requestData.length > 0) {
                            if (this.project.requestData.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                              if (this.project.IsRoundStatus == '0') {
                                if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                                  CheckDupe = true
                                }
                              } else {
                                if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                                  CheckDupe = true
                                }
                              }
                              if (!CheckDupe) {
                                this.insertDataToDB({
                                  Project_code: this.project.Project_code,
                                  D_project_round_id: this.project.id,
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                    })
                                    this.projectDataToTableDump2 = ''
                                    this.init()
                                  } else {
                                    this.$swal.fire({
                                      icon: 'error',
                                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                    })
                                  }
                                })
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                              })
                            }
                          } else {
                            // ทำอะไรสักอย่างตรงนี้
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              D_project_round_id: this.project.id,
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                this.projectDataToTableDump2 = ''
                                this.init()
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          }
                        } else {
                          countPerson = 0
                          this.project.requestData.map(reqP => {
                            if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                              countPerson++
                            }
                          })

                          if ((this.project.requestData.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                            if (this.project.IsRoundStatus == '0') {
                              if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                                CheckDupe = true
                              }
                            } else {
                              if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                                CheckDupe = true
                              }
                            }
                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                D_project_round_id: this.project.id,
                                perid: staff_I.perid,
                                status_req: '0',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                  })
                                  this.projectDataToTableDump2 = ''
                                  this.init()
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                  })
                                }
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                            })
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                if (this.project.requestData.length < parseInt(this.project.Count_Reg)) {
                  if (this.project.IsRoundStatus == '0') {
                    if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                      CheckDupe = true
                    }
                  } else {
                    if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                      CheckDupe = true
                    }
                  }
                  if (!CheckDupe) {
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      perid: staff_I.perid,
                      status_req: '0',
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res.status) {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                        })
                        this.projectDataToTableDump2 = ''
                        this.init()
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                        })
                      }
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
                  })
                }
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
              })
            }
          } else if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map((dep_quota, idx) => {
              if (dep_quota.dep_type == '0' && !CheckDepMatch) {
                if (staff_I.dep_id == dep_quota.dep_id) {
                  CheckDepMatch = true
                  if (this.project.requestData.length > 0) {
                    if (this.project.requestData.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                      if (this.project.IsRoundStatus == '0') {
                        if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                          CheckDupe = true
                        }
                      } else {
                        if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                          CheckDupe = true
                        }
                      }

                      if (!CheckDupe) {
                        this.insertDataToDB({
                          Project_code: this.project.Project_code,
                          D_project_round_id: this.project.id,
                          perid: staff_I.perid,
                          status_req: '0',
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                            })
                            this.projectDataToTableDump2 = ''
                            this.init()
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                      })
                    }
                  } else {
                    this.insertDataToDB({
                      Project_code: this.project.Project_code,
                      D_project_round_id: this.project.id,
                      perid: staff_I.perid,
                      status_req: '0',
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }).then(res => {
                      if (res.status) {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                        })
                        this.projectDataToTableDump2 = ''
                        this.init()
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                        })
                      }
                    })
                  }
                } else {
                  if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                    if (this.project.Status_Count_Reg == '1') {
                      if (this.project.IsRoundStatus == '0') {
                        if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                          CheckDupe = true
                        }
                      } else {
                        if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                          CheckDupe = true
                        }
                      }
                      if (!CheckDupe) {
                        this.insertDataToDB({
                          Project_code: this.project.Project_code,
                          D_project_round_id: this.project.id,
                          perid: staff_I.perid,
                          status_req: '0',
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                            })
                            this.projectDataToTableDump2 = ''
                            this.init()
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    } else {
                      countPerson = 0
                      this.project.requestData.map(reqP => {
                        if (dep_quota.dep_id == reqP.dep_id) {
                          countPerson++
                        }
                      })

                      if ((this.project.requestData.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                        if (this.project.IsRoundStatus == '0') {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                            CheckDupe = true
                          }
                        } else {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                            CheckDupe = true
                          }
                        }
                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            D_project_round_id: this.project.id,
                            perid: staff_I.perid,
                            status_req: '0',
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                              this.projectDataToTableDump2 = ''
                              this.init()
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                        })
                      }
                    }
                  }
                }
              } else {
                //// ตรงนี้ต้องเช็ค
                if (!CheckDepMatch) {
                  var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                  if (DepGroup.length > 0) {
                    if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                      CheckDepMatch = true
                      if (this.project.requestData.length > 0) {
                        if (this.project.requestData.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                          if (this.project.IsRoundStatus == '0') {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                              CheckDupe = true
                            }
                          } else {
                            if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                              CheckDupe = true
                            }
                          }
                          if (!CheckDupe) {
                            this.insertDataToDB({
                              Project_code: this.project.Project_code,
                              D_project_round_id: this.project.id,
                              perid: staff_I.perid,
                              status_req: '0',
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }).then(res => {
                              if (res.status) {
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                                })
                                this.projectDataToTableDump2 = ''
                                this.init()
                              } else {
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                                })
                              }
                            })
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                          })
                        }
                      } else {
                        //// ทำอะไรสักอย่างตรงนี้
                        this.insertDataToDB({
                          Project_code: this.project.Project_code,
                          D_project_round_id: this.project.id,
                          perid: staff_I.perid,
                          status_req: '0',
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }).then(res => {
                          if (res.status) {
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                            })
                            this.projectDataToTableDump2 = ''
                            this.init()
                          } else {
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                            })
                          }
                        })
                      }
                    } else {
                      countPerson = 0
                      this.project.requestData.map(reqP => {
                        if (DepGroup.filter(item => item.dep_id == reqP.dep_id).length > 0) {
                          countPerson++
                        }
                      })

                      if ((this.project.requestData.length + (parseInt(this.ProjectQuotaDepCount) - countPerson)) < parseInt(this.project.Count_Reg)) {
                        if (this.project.IsRoundStatus == '0') {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                            CheckDupe = true
                          }
                        } else {
                          if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                            CheckDupe = true
                          }
                        }
                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            D_project_round_id: this.project.id,
                            perid: staff_I.perid,
                            status_req: '0',
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.$swal.fire({
                                timer: 1500,
                                showConfirmButton: false,
                                icon: 'success',
                                title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                              })
                              this.projectDataToTableDump2 = ''
                              this.init()
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                              })
                            }
                          })
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                        })
                      }
                    }
                  }
                }
              }
            })
          } else {
            if (this.project.requestData.length < parseInt(this.project.Count_Reg)) {
              if (this.project.IsRoundStatus == '0') {
                if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code).length > 0) {
                  CheckDupe = true
                }
              } else {
                if (this.project.requestData.filter(item => item.perid == staff_I.perid && item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.Ref_id).length > 0) {
                  CheckDupe = true
                }
              }
              if (!CheckDupe) {
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  perid: staff_I.perid,
                  status_req: '0',
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res.status) {
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                    })
                    this.projectDataToTableDump2 = ''
                    this.init()
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                    })
                  }
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
              })
            }
          }
        }
      })
      // }
    },
    ChooseEmpolyee_s_owner() {
      var CheckDupe = false
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          this.staffData.map((staff_I) => {
            if (staff_I.perid == this.staffSel) {
              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  perid: staff_I.perid,
                  status_req: '0',
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                }).then(res => {
                  if (res.status) {
                    this.RequestPerson.unshift({
                      ...staff_I,
                      id: res.data.id,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_req: res.data.status_req,
                      status_active: res.data.status_active,
                      position: '',
                      phone: '',
                      remark: '',
                      registerType_id: 0,
                    })
                    this.staffSel = ''
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + staff_I.full_Name + ' สำเร็จ!!'
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผืดพลาด ไม่สามารถบันทึกข้อมูลได้'
                    })
                  }
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      var CheckDupe = false
      var CheckPermiss = false
      if (this.PermissionAdmin.length > 0) {
        this.PermissionAdmin.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.JoinPerson.filter(item => item.uid == ('P_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'P_' + this.JoinPerson.length,
                  full_Name: this.NameP + ' ' + this.SurNameP,
                  name: this.NameP,
                  sname: this.SurNameP,
                  idCard: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: 'P_' + this.JoinPerson.length,
                  name: this.NameP,
                  sname: this.SurNameP,
                  id_card: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                })
                this.NameP = ''
                this.SurNameP = ''
                this.idCard = ''
                this.affiliation = ''
                this.position = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            } else {
              if (this.JoinPerson.filter(item => item.uid == ('S_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'S_' + this.JoinPerson.length,
                  full_Name: this.NameStd + ' ' + this.SurNameStd,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  idCard: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: 'S_' + this.JoinPerson.length,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  id_card: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                })
                this.NameStd = ''
                this.SurNameStd = ''
                this.idCardStd = ''
                this.affiliationStd = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }

            }
          } else {
            if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      } else {
        this.Permission.map((Per_i, idx) => {
          if (Per_i.permission_id == '7001') {
            CheckPermiss = true
            if (type == 'person') {
              if (this.JoinPerson.filter(item => item.uid == ('P_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'P_' + this.JoinPerson.length,
                  full_Name: this.NameP + ' ' + this.SurNameP,
                  name: this.NameP,
                  sname: this.SurNameP,
                  idCard: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: 'P_' + this.JoinPerson.length,
                  name: this.NameP,
                  sname: this.SurNameP,
                  id_card: this.idCard,
                  affiliation: this.affiliation,
                  position: this.position,
                  phone: this.phoneOther,
                  registerType_id: 4,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + this.NameP + ' ' + this.SurNameP + ' สำเร็จ!!'
                })
                this.NameP = ''
                this.SurNameP = ''
                this.idCard = ''
                this.affiliation = ''
                this.position = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            } else {
              if (this.JoinPerson.filter(item => item.uid == ('S_' + this.JoinPerson.length)).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  uid: 'S_' + this.JoinPerson.length,
                  full_Name: this.NameStd + ' ' + this.SurNameStd,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  idCard: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                })
                this.insertDataToDB({
                  Project_code: this.project.Project_code,
                  D_project_round_id: this.project.id,
                  uid: 'S_' + this.JoinPerson.length,
                  name: this.NameStd,
                  sname: this.SurNameStd,
                  id_card: this.idCardStd,
                  affiliation: this.affiliationStd,
                  position: '',
                  phone: this.phoneOther,
                  registerType_id: 5,
                  Create_By: this.MeData[0].perid,
                  Create_Time: 'now()',
                })
                this.$swal.fire({
                  timer: 1500,
                  showConfirmButton: false,
                  icon: 'success',
                  title: 'บันทึกข้อมูลผู้เข้าร่วมโครงการ ' + this.NameStd + ' ' + this.SurNameStd + ' สำเร็จ!!'
                })
                this.NameStd = ''
                this.SurNameStd = ''
                this.idCardStd = ''
                this.affiliationStd = ''
                this.phoneOther = ''
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }

            }
          } else {
            if (!CheckPermiss && idx == this.Permission.length - 1) {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          }
        })
      }
    },
    SaveToTable() {
      var CheckDupe = false
      var CheckDepMatch = false
      var CheckGroupExample = []
      this.ShowAlertSuc = false
      this.ShowAlertErr = false
      this.MessageSuc = ''
      this.MessageError = ''
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          if (this.project.Status_Count_Reg == '0' && this.RequestPerson.length >= parseInt(this.project.Count_Reg)) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
            })
          } else {
            this.EmpData.map((item, EmpIdx) => {
              CheckDupe = false
              CheckDepMatch = false
              CheckGroupExample = []
              this.staffData.map((staff_I) => {
                if (staff_I.perid == item.perid) {
                  if (this.GroupExamData.length > 0) {
                    CheckGroupExample = this.GroupExamData.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

                    if (CheckGroupExample.length > 0) {
                      if (this.DepQuotaData.length > 0) {
                        this.DepQuotaData.map((dep_quota, idx) => {
                          if (dep_quota.type_id == '0' && !CheckDepMatch) {
                            if (staff_I.dep_id == dep_quota.dep_id) {
                              CheckDepMatch = true
                              if (this.RequestPerson.length > 0) {
                                if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }

                                  if (!CheckDupe) {

                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      D_project_round_id: this.project.id,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })

                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: chocolate">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    D_project_round_id: this.project.id,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                      })
                                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                      this.ShowAlertSuc = true
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  })
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              }
                            } else {
                              if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                                if (this.ChkRequestPerson) {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      D_project_round_id: this.project.id,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  if ((this.RequestPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                      CheckDupe = true
                                    }
                                    if (!CheckDupe) {
                                      this.insertDataToDB({
                                        Project_code: this.project.Project_code,
                                        D_project_round_id: this.project.id,
                                        perid: staff_I.perid,
                                        status_req: '0',
                                        Create_By: this.MeData[0].perid,
                                        Create_Time: 'now()',
                                      }).then(res => {
                                        if (res.status) {
                                          this.RequestPerson.unshift({
                                            ...staff_I,
                                            id: res.data.id,
                                            uid: staff_I.perid,
                                            name: staff_I.name,
                                            sname: staff_I.surname,
                                            idCard: staff_I.citizen_id,
                                            affiliation: staff_I.dep_name,
                                            status_req: res.data.status_req,
                                            status_active: res.data.status_active,
                                            position: '',
                                            phone: '',
                                            remark: '',
                                            registerType_id: 0,
                                          })
                                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                          this.ShowAlertSuc = true
                                        } else {
                                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                          this.ShowAlertErr = true
                                        }
                                      })
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                }
                              }
                            }
                          } else {
                            //// ตรงนี้ต้องเช็ค
                            if (!CheckDepMatch) {
                              var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                              if (DepGroup.length > 0) {
                                if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                                  CheckDepMatch = true
                                  if (this.RequestPerson.length > 0) {
                                    if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                      if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                        CheckDupe = true
                                      }
                                      if (!CheckDupe) {
                                        this.insertDataToDB({
                                          Project_code: this.project.Project_code,
                                          D_project_round_id: this.project.id,
                                          perid: staff_I.perid,
                                          status_req: '0',
                                          Create_By: this.MeData[0].perid,
                                          Create_Time: 'now()',
                                        }).then(res => {
                                          if (res.status) {
                                            this.RequestPerson.unshift({
                                              ...staff_I,
                                              id: res.data.id,
                                              uid: staff_I.perid,
                                              name: staff_I.name,
                                              sname: staff_I.surname,
                                              idCard: staff_I.citizen_id,
                                              affiliation: staff_I.dep_name,
                                              status_req: res.data.status_req,
                                              status_active: res.data.status_active,
                                              position: '',
                                              phone: '',
                                              remark: '',
                                              registerType_id: 0,
                                            })
                                            this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                            this.ShowAlertSuc = true
                                          } else {
                                            this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                            this.ShowAlertErr = true
                                          }
                                        })
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                      this.ShowAlertErr = true
                                    }
                                  } else {
                                    this.RequestPerson.unshift({
                                      ...staff_I,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_reg: this.rdoRegisterProject,
                                      position: '',
                                      phone: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  }
                                }
                              }
                            }
                          }
                        })
                      } else {
                        if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.insertDataToDB({
                            Project_code: this.project.Project_code,
                            D_project_round_id: this.project.id,
                            perid: staff_I.perid,
                            status_req: '0',
                            Create_By: this.MeData[0].perid,
                            Create_Time: 'now()',
                          }).then(res => {
                            if (res.status) {
                              this.RequestPerson.unshift({
                                ...staff_I,
                                id: res.data.id,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_req: res.data.status_req,
                                status_active: res.data.status_active,
                                position: '',
                                phone: '',
                                remark: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                              this.ShowAlertErr = true
                            }
                          })
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                          this.ShowAlertErr = true
                        }
                      }
                    } else {
                      this.MessageError += '<p style="font-weight: bold;color: darkcyan">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>'
                      this.ShowAlertErr = true
                    }
                  } else if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((dep_quota, idx) => {
                      if (dep_quota.type_id == '0' && !CheckDepMatch) {
                        if (staff_I.dep_id == dep_quota.dep_id) {
                          CheckDepMatch = true
                          if (this.RequestPerson.length > 0) {
                            if (this.RequestPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }

                              if (!CheckDupe) {
                                this.insertDataToDB({
                                  Project_code: this.project.Project_code,
                                  D_project_round_id: this.project.id,
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.RequestPerson.unshift({
                                      ...staff_I,
                                      id: res.data.id,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_req: res.data.status_req,
                                      status_active: res.data.status_active,
                                      position: '',
                                      phone: '',
                                      remark: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                })
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.insertDataToDB({
                                Project_code: this.project.Project_code,
                                D_project_round_id: this.project.id,
                                perid: staff_I.perid,
                                status_req: '0',
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }).then(res => {
                                if (res.status) {
                                  this.RequestPerson.unshift({
                                    ...staff_I,
                                    id: res.data.id,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_req: res.data.status_req,
                                    status_active: res.data.status_active,
                                    position: '',
                                    phone: '',
                                    remark: '',
                                    registerType_id: 0,
                                  })
                                  this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                  this.ShowAlertSuc = true
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                  this.ShowAlertErr = true
                                }
                              })
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          }
                        } else {
                          if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                            if (this.project.Status_Count_Reg == '1') {
                              if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.insertDataToDB({
                                  Project_code: this.project.Project_code,
                                  D_project_round_id: this.project.id,
                                  perid: staff_I.perid,
                                  status_req: '0',
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }).then(res => {
                                  if (res.status) {
                                    this.RequestPerson.unshift({
                                      ...staff_I,
                                      id: res.data.id,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_req: res.data.status_req,
                                      status_active: res.data.status_active,
                                      position: '',
                                      phone: '',
                                      remark: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                })
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              if ((this.RequestPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                                if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.insertDataToDB({
                                    Project_code: this.project.Project_code,
                                    D_project_round_id: this.project.id,
                                    perid: staff_I.perid,
                                    status_req: '0',
                                    Create_By: this.MeData[0].perid,
                                    Create_Time: 'now()',
                                  }).then(res => {
                                    if (res.status) {
                                      this.RequestPerson.unshift({
                                        ...staff_I,
                                        id: res.data.id,
                                        uid: staff_I.perid,
                                        name: staff_I.name,
                                        sname: staff_I.surname,
                                        idCard: staff_I.citizen_id,
                                        affiliation: staff_I.dep_name,
                                        status_req: res.data.status_req,
                                        status_active: res.data.status_active,
                                        position: '',
                                        phone: '',
                                        remark: '',
                                        registerType_id: 0,
                                      })
                                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                      this.ShowAlertSuc = true
                                    } else {
                                      this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                      this.ShowAlertErr = true
                                    }
                                  })
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                this.ShowAlertErr = true
                              }
                            }
                          }
                        }
                      } else {
                        //// ตรงนี้ต้องเช็ค
                        if (!CheckDepMatch) {
                          var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                          if (DepGroup.length > 0) {
                            if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                              CheckDepMatch = true
                              if (this.RequestPerson.length > 0) {
                                if (this.RequestPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                  if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.insertDataToDB({
                                      Project_code: this.project.Project_code,
                                      D_project_round_id: this.project.id,
                                      perid: staff_I.perid,
                                      status_req: '0',
                                      Create_By: this.MeData[0].perid,
                                      Create_Time: 'now()',
                                    }).then(res => {
                                      if (res.status) {
                                        this.RequestPerson.unshift({
                                          ...staff_I,
                                          id: res.data.id,
                                          uid: staff_I.perid,
                                          name: staff_I.name,
                                          sname: staff_I.surname,
                                          idCard: staff_I.citizen_id,
                                          affiliation: staff_I.dep_name,
                                          status_req: res.data.status_req,
                                          status_active: res.data.status_active,
                                          position: '',
                                          phone: '',
                                          remark: '',
                                          registerType_id: 0,
                                        })
                                        this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                        this.ShowAlertSuc = true
                                      } else {
                                        this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                                        this.ShowAlertErr = true
                                      }
                                    })
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.RequestPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              }
                            }
                          }
                        }
                      }
                    })
                  } else {
                    if (this.RequestPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.insertDataToDB({
                        Project_code: this.project.Project_code,
                        D_project_round_id: this.project.id,
                        perid: staff_I.perid,
                        status_req: '0',
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }).then(res => {
                        if (res.status) {
                          this.RequestPerson.unshift({
                            ...staff_I,
                            id: res.data.id,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_req: res.data.status_req,
                            status_active: res.data.status_active,
                            position: '',
                            phone: '',
                            remark: '',
                            registerType_id: 0,
                          })
                          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                          this.ShowAlertSuc = true
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ !!</p>'
                          this.ShowAlertErr = true
                        }
                      })
                    } else {
                      this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                      this.ShowAlertErr = true
                    }
                  }
                }
              })
              if (EmpIdx == this.EmpData.length - 1) {
                this.EmpData = []
                this.items = []
                this.departSel = ''
              }
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    SaveToTable_owner() {
      var CheckDupe = false
      this.MessageError = ''
      this.MessageSuc = ''
      this.CheckPermissFunc('7001').then(resPermiss => {
        if (resPermiss) {
          this.EmpData.map((item) => {
            CheckDupe = false
            if (this.JoinPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
              CheckDupe = true
            }
            if (!CheckDupe) {

              this.insertDataToDB({
                Project_code: this.project.Project_code,
                D_project_round_id: this.project.id,
                perid: item.perid,
                status_req: '0',
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }).then(res => {
                if (res.status) {
                  this.RequestPerson.unshift({
                    ...item,
                    id: res.data.id,
                    uid: item.perid,
                    name: item.name,
                    sname: item.surname,
                    idCard: item.citizen_id,
                    affiliation: item.dep_name,
                    status_req: res.data.status_req,
                    status_active: res.data.status_active,
                    position: '',
                    phone: '',
                    remark: '',
                    registerType_id: 0,
                  })
                  this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                  this.ShowAlertSuc = true
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErr = true
                }
              })
            } else {
              this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
              this.ShowAlertErr = true
            }
          })
          this.EmpData = []
          this.items = []
          this.departSel = ''
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    GetDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      return yyyy + '-' + mm + '-' + dd;
    },
    ShowJoinProject(item) {
      this.dialogJoinProject = true
      this.project = null
      this.project = item
    },
    ShowCordiProject(item) {
      // console.log(item)
      this.dialogCordiProject = true
      this.project = null
      this.project = item
      this.QoutaDepDataDump = []
      this.DepQuotaData = []
      this.ProjectQuotaDepCount = 0
      this.GroupExamData = []

      this.QoutaDepDataDump = this.UniqueArraybyId(this.QuotaDepart, 'id')
      if (item.IsRoundStatus == '0') {
        this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)
      } else {
        this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code && item.D_project_round_id == this.project.id)
      }
      // console.log(this.QuotaDepart)
      if (this.QoutaDepDataDump.length > 0) {
        this.QoutaDepDataDump.map(DepQ => {
          this.ProjectQuotaDepCount += parseInt(DepQ.count)
        })
        this.DepQuotaData = this.QoutaDepDataDump
      }

      this.initGroupExamProject({
        Project_code: this.project.Project_code
      }).then(resGroup => {
        if (resGroup) {
          if (item.IsRoundStatus == '0') {
            this.GroupExamData = this.GroupExamProject
          } else {
            var GroupExDump = this.GroupExamProject.filter(GroupI => GroupI.D_project_round_id == item.id)
            if (GroupExDump.length > 0) {
              this.GroupExamData = GroupExDump
            }
          }
        }
      })

    },
    showDetails: function (item) {
      var CheckCordi = false
      var CheckCordi2 = '0'
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
          if ((this.GetDateNow() >= item.DateS_Reg) && (this.GetDateNow() <= item.DateE_Reg)) {
            CheckCordi = true
          } else {
            CheckCordi = false
            CheckCordi2 = '1'
          }
        } else if ((item.DateS_Reg != null && item.DateS_Reg != '0000-00-00') && (item.DateE_Reg == null || item.DateE_Reg == '0000-00-00')) {
          if (this.GetDateNow() >= item.DateS_Reg) {
            CheckCordi = true
          } else {
            CheckCordi = false
            CheckCordi2 = '2'
          }
        } else if ((item.DateS_Reg == null || item.DateS_Reg == '0000-00-00') && (item.DateE_Reg != null && item.DateE_Reg != '0000-00-00')) {
          if (this.GetDateNow() <= item.DateE_Reg) {
            CheckCordi = true
          } else {
            CheckCordi = false
            CheckCordi2 = '3'
          }
        } else {
          CheckCordi = false
          CheckCordi2 = '4'
        }

        if (CheckCordi) {
          this.project = item
          this.Details_Cordi = true;
          this.JoinPerson = []
          this.RequestPerson = []

          this.QoutaDepDataDump = this.UniqueArraybyId(this.QoutaDepData, 'id')
          this.QoutaDepDataDump = this.QoutaDepDataDump.filter(item => item.Project_code == this.project.Project_code)

          this.initGroupExamProject({
            Project_code: this.project.Project_code
          })
          this.initJoinProject({
            Project_code: item.Project_code
          }).then(resJoin => {
            if (resJoin) {
              this.JoinProject.map(Join_i => {
                this.JoinPerson.unshift({
                  ...Join_i,
                  full_Name: Join_i.name + ' ' + Join_i.sname,
                  idCard: Join_i.id_card,
                  status_reg_person: '0'
                })
              })
            }
          })
          this.initRequestProject({
            Project_code: item.Project_code
          }).then(res => {
            if (res) {
              if (this.RequestProject.length > 0) {
                this.staffData.map((staff_I) => {
                  this.RequestProject.map(itemReq => {
                    if (staff_I.perid == itemReq.perid) {
                      this.RequestPerson.unshift({
                        ...staff_I,
                        id: itemReq.id,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_req: itemReq.status_req,
                        status_active: itemReq.status_active,
                        position: '',
                        phone: '',
                        remark: itemReq.remark,
                        registerType_id: 0,
                      })
                    }
                  })
                })
              }
            }
          })
        } else {
          switch (CheckCordi2) {
            case "1":
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากไม่ได้อยู่ในช่วงรับที่เปิดรับสมัคร'
              })
              break
            case "2":
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร'
              })
              break
            case "3":
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ หมดระยะเวลาการรับสมัคร'
              })
              break
            case "4":
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถสมัครเข้าร่วมโครงการได้ เนื่องจากโครงการไม่ระบุวันที่ เปิด - ปิด การรับสมัคร'
              })
              break
            default:
              break
          }
        }
      }
    },
    insertDataToDB(RegObj) {
      return new Promise(resolve => {
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project', RegObj, headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/request_project/Project_code/' + RegObj.Project_code + '/perid/' + RegObj.perid + '/?limit=1', '', headerAxios).then(resGet => {
              resolve({
                status: true,
                data: resGet.data
              })
            })
          } else {
            resolve({
              status: false,
              data: ''
            })
          }
        })
      })
    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    }
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.dialogLoading = true
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '2'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '2' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.fixpage = false
              if (!this.fixpage) {
                this.init()
              }
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '2' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '2')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
              this.dialogLoading = false
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '2' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '2')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
            this.dialogLoading = false
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
